module.exports = __webpack_public_path__ + "media/assets/images/connectors/gcp-logo-c228342a9f3fd951b32c2cfa069b50b0.svg";